export default __webpack_public_path__ + "static/media/Xiaomi.17c2db63.svg";